import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-expressions */
import {
  Button,
  Card,
  CardTitle,
  CardText,
  Container,
  Form,
  Row,
  Label,
  Col,
  Input,
  FormGroup,
} from 'reactstrap';

/**
 * @summary Render MonthlyDateBasedPayRollForm component
 *
 * @param {object} props The components' props
 * @returns {Component}
 */
const MonthlyDateBasedPayRollForm = (props) => {
  const {
    handleInputChange,
    monthlyDateBasedPayrollPayload,
    triedSubmitting,
  } = props;

  return (
    <>
      <Container>
        <div>
          <Card body outline color="secondary">
            <CardTitle tag="h5">Monthly - Date Based</CardTitle>
            <CardText>
              <Form>
                <Row form>
                  <Col>
                    <FormGroup>
                      <Label for="payCycleName">Name</Label>
                      <Input
                        type="text"
                        bsSize="sm"
                        name="payCycleName"
                        id="payCycleName"
                        placeholder="Pay Cycle Name e.g. CompanyX - Monthly Date Based"
                        onChange={(e) => handleInputChange(e)}
                        invalid={
                          triedSubmitting &&
                          !monthlyDateBasedPayrollPayload?.payCycleName?.trim()
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="payDate">Pay Date</Label>

                      <Input
                        type="number"
                        name="payDate"
                        bsSize="sm"
                        id="payDate"
                        onChange={(e) => handleInputChange(e)}
                        invalid={
                          triedSubmitting &&
                          !monthlyDateBasedPayrollPayload?.payDate
                        }
                      />
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup>
                      <Label for="advanceReconDate">Advance Recon Date</Label>
                      <Input
                        bsSize="sm"
                        type="number"
                        name="advanceReconDate"
                        id="advanceReconDate"
                        placeholder="advance recon date"
                        onChange={(e) => handleInputChange(e)}
                        invalid={
                          triedSubmitting &&
                          !monthlyDateBasedPayrollPayload?.advanceReconDate
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Button size="sm" color="primary">
                        Save{' '}
                      </Button>{' '}
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </CardText>
          </Card>
          <br />
        </div>{' '}
        <br />
      </Container>
    </>
  );
};

MonthlyDateBasedPayRollForm.defaultProps = {};

MonthlyDateBasedPayRollForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
};

export default MonthlyDateBasedPayRollForm;
